import { render } from "./QuestionareTitle.vue?vue&type=template&id=6f6c3b40&scoped=true"
import script from "./QuestionareTitle.vue?vue&type=script&lang=js"
export * from "./QuestionareTitle.vue?vue&type=script&lang=js"

import "./QuestionareTitle.vue?vue&type=style&index=0&id=6f6c3b40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f6c3b40"

export default script